import { makeStyles, Theme } from '@material-ui/core/styles';
import { sidebarWidth } from '../Components/SideBar/Sidebar.styles';
export const useStyles = makeStyles((theme:Theme) => ({
  content: {
    flexGrow: 1,
    width: `calc(100% - ${theme.spacing(8)})`,
  },
  contentShift: {
    width: `calc(100% - ${sidebarWidth}rem)`,
  },
  marginBottom10: {
    marginBottom:10
  },
  toolbar: theme.mixins.toolbar,
  subMenuToolbar: {
    minHeight: '3rem',
  },
  content2: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  content3: {
    flexGrow: 1,
    padding: theme.spacing(4),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 240,
  },
  contentShift2: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  submitButton: {
    marginTop: theme.spacing(2),
    minWidth:100,
   
  },
  formControl: {
    //margin: theme.spacing(1.4),
    marginTop:15,
    minWidth:240,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  paddingRight40:{
    paddingRight:40,
  },
  buttonStyle:{
    marginTop:25
  },
  selectDropdown: {
    //margin: theme.spacing(1.4),
    minWidth:380,
    },
}));
